import { createEvent } from "effector";
import { UserOffice } from "@type/core/auth/auth.types";

export const setOffices = createEvent<UserOffice[]>("SET_OFFICES");
export const setSelectedOffices = createEvent<UserOffice[]>(
  "SET_SELECTED_OFFICES",
);
export const setAreOfficesLoading = createEvent<boolean>("ARE_OFFICES_LOADING");
export const setSelectedOfficeInStore = createEvent<UserOffice>(
  "SET_SELECTED_OFFICE",
);
